var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/editor/redo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9sux84qcoa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/editor/redo (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/editor/redo (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/editor/redo",
    style: {
      clipPath: "url(#9sux84qcoa)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/editor/redo (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/editor/redo (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.328 14.75a7.032 7.032 0 1 0-8.764-.088.143.143 0 0 0 .2-.023l.693-.888a.141.141 0 0 0-.021-.2 5.462 5.462 0 0 1-.412-.371 5.6 5.6 0 0 1-1.206-1.784 5.634 5.634 0 0 1 0-4.375 5.629 5.629 0 0 1 10.366 0 5.616 5.616 0 0 1-1.206 6.165 5.73 5.73 0 0 1-.515.457l-.715-.916a.141.141 0 0 0-.248.053l-.7 2.851a.141.141 0 0 0 .135.174l2.936.014a.14.14 0 0 0 .111-.227z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.9fedb00594af463accf4bdb013b0f92f.svg";
export { ForwardRef as ReactComponent };